import {ShadowError} from "./interfaces";
import {ErrorCode} from "./ErrorCode";

export class GatewayError extends Error {
    errorCode: ErrorCode;
    data: any;

    constructor(error: ShadowError) {
        super();
        this.name = 'Gateway Error';
        this.message = error.message;
        this.errorCode = error.errorCode;
        this.data = error.data;
    }
}
